export class VehicleMaintenanceScheduleServiceDueQueryParameters {
  embed?: any;
  overdue?: boolean;
  page?: number;
  pageSize?: number;
  serviceGroupId?: string;
  vehicleId?: number;

  constructor(obj?: VehicleMaintenanceScheduleServiceDueQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
